var _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrontOfCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 172 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 171,
    height: 92.1128,
    rx: 7.5,
    fill: "white",
    stroke: "#D8D8D8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36.8571,
    height: 36.8571,
    transform: "translate(15.5195 15.5186)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.0195,
    y: 16.0186,
    width: 36,
    height: 36,
    rx: 3.5,
    stroke: "#D8D8D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9475 17.0547C24.6227 17.0547 17.0547 24.6227 17.0547 33.9475C17.0547 43.2724 24.6227 50.8404 33.9475 50.8404C43.2724 50.8404 50.8404 43.2724 50.8404 33.9475C50.8404 24.6227 43.2724 17.0547 33.9475 17.0547ZM33.9475 22.1225C36.7518 22.1225 39.0154 24.3862 39.0154 27.1904C39.0154 29.9946 36.7518 32.2583 33.9475 32.2583C31.1433 32.2583 28.8797 29.9946 28.8797 27.1904C28.8797 24.3862 31.1433 22.1225 33.9475 22.1225ZM33.9475 46.1104C30.1691 46.1104 26.7827 44.3796 24.5508 41.6679C24.0369 41.0436 23.7486 40.1967 24.1242 39.4805C25.4894 36.8771 30.9919 35.4679 33.9475 35.4679C36.8885 35.4679 42.4023 36.8772 43.7703 39.4807C44.1465 40.1966 43.8582 41.0436 43.3443 41.6679C41.1123 44.3796 37.726 46.1104 33.9475 46.1104Z",
    fill: "#C2C2C2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 59.4883,
    y: 15.5186,
    width: 83.4135,
    height: 8.40602,
    fill: "#C2C2C2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5195,
    y: 72.4209,
    width: 57.5489,
    height: 8.40602,
    fill: "#C2C2C2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 85.3535,
    y: 72.4209,
    width: 71.1278,
    height: 8.40602,
    fill: "#C2C2C2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 59.4883,
    y: 29.7441,
    width: 62.7218,
    height: 5.81955,
    fill: "#D8D8D8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 59.4883,
    y: 37.5039,
    width: 62.7218,
    height: 5.81955,
    fill: "#D8D8D8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 59.4883,
    y: 45.2627,
    width: 62.7218,
    height: 5.81955,
    fill: "#D8D8D8"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 59.4883,
    y: 53.0225,
    width: 53.0226,
    height: 5.81955,
    fill: "#D8D8D8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontOfCard);
export default __webpack_public_path__ + "static/media/front-of-card.9ad20fee.svg";
export { ForwardRef as ReactComponent };